var noop = function noop() {};

export default noop;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/noop.js
// module id = 5t3W
// module chunks = 0